import React from "react";
import { useField } from "formik";

import {
  FormField,
  RadioButton,
  RadioButtonGroup,
} from "@justworkshr/milo-form";

import styles from "./RadioInput.module.css";
interface IRadioInputProps {
  name: string;
  label: string;
  onBlur?: () => void;
  onFocus?: () => void;
  options: string[];
  message?: string;
  required?: boolean;
  disabled?: boolean;
  fieldRefs?: React.MutableRefObject<{
    [key: string]: HTMLInputElement | null;
  }>;
}

const RadioInput = ({ ...props }: IRadioInputProps): JSX.Element => {
  const {
    name,
    label,
    required = true,
    options,
    message,
    disabled,
    fieldRefs,
  } = props;
  const [field, meta] = useField(props);

  return (
    <div
      className={styles.container}
      ref={(el) => {
        if (fieldRefs?.current) {
          fieldRefs.current[name] = el as HTMLInputElement | null;
        }
      }}
    >
      <FormField
        required={required}
        label={label}
        error={meta.touched ? meta.error : ""}
        message={message}
      >
        <div>
          <RadioButtonGroup {...field}>
            {options.map((option) => {
              return (
                <RadioButton
                  data-testid={`${name}-${option}`}
                  key={option}
                  id={`${name}-${option}`}
                  label={option}
                  checked={field.value === option}
                  disabled={disabled}
                  {...field}
                  value={option}
                />
              );
            })}
          </RadioButtonGroup>
        </div>
      </FormField>
    </div>
  );
};

export default RadioInput;
